import axiosInsAcademy from '@/api/axios-ugems-academy';

export default {
  // Get all TNA periods
  getTNAPeriods(params) {
    return axiosInsAcademy.get('/tna-period', { params });
  },

  // Create new TNA period
  createTNAPeriod(data) {
    return axiosInsAcademy.post('/tna-period', data);
  },

  // Update TNA period
  updateTNAPeriod(id, data) {
    return axiosInsAcademy.put(`/tna-period/${id}`, data);
  }
};
